import { Component, Inject } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { NewUserEmailDTO } from "@shared/model/user.model";
import { AdminService } from "@shared/services/admin/admin.service";

@Component({
	selector: "app-newuser-dialog",
	templateUrl: "./newuser-dialog.component.html",
	styleUrl: "./newuser-dialog.component.scss",
	standalone: false
})
export class NewuserDialogComponent {
	newUserForm: UntypedFormGroup = new UntypedFormGroup({
		email: new UntypedFormControl("", [Validators.required, Validators.email])
	});
	dealerId: number;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: number,
		private adminService: AdminService,
		public dialogRef: MatDialogRef<NewuserDialogComponent>
	) {
		this.dealerId = data;
	}
	sendEmail() {
		if (!this.newUserForm.invalid) {
			const dto = new NewUserEmailDTO();
			dto.email = this.newUserForm.controls["email"].value;
			dto.dealerId = this.dealerId;

			this.adminService.sendEmailUserUsingPOST(dto).subscribe(() => {
				this.dialogRef.close();
			});
		}
	}
}
